<template>
	<div>
  <el-descriptions
    style="margin-top: 20px; margin-bottom: 20px"
    size="mini"
    class="margin-top"
    title="申请信息"
    border
  >
    <el-descriptions-item v-if="biao.hosp">
      <template slot="label">
        <i class="el-icon-office-building"></i>
        申请机构
      </template>
      {{ biao.hosp }}
    </el-descriptions-item>
    <el-descriptions-item v-if="biao.type">
      <template slot="label">
        <i class="el-icon-paperclip"></i>
        申请类型
      </template>
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <span>{{ biao.type }}</span>
        <el-button
          type="text"
          size="mini"
          @click="showChangeTypeDialog"
          style="color: #409eff; padding: 0;"
        >
          更改
        </el-button>
      </div>
    </el-descriptions-item>
    <el-descriptions-item v-if="cjtypes">
      <template slot="label"> 残疾类型 </template>
      <span
        style="margin-left: 5px; margin-right: 5px"
        v-for="(p, i) in cjtypes"
        :key="i"
        >{{ p }}</span
      >
    </el-descriptions-item>
    <el-descriptions-item v-if="biao.yibao">
      <template slot="label"> 医保类型 </template>
      {{ biao.yibao }}
    </el-descriptions-item>
    <el-descriptions-item v-if="biao.yhcard">
      <template slot="label"> 送训银行卡号 </template>
      {{ biao.yhcard }}
    </el-descriptions-item>
  </el-descriptions>
  <div style="margin-top: 20px;">
    <el-button
      type="primary"
      size="mini"
      @click="isHistoryOpen = !isHistoryOpen"
      :icon="isHistoryOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
    >
      {{ isHistoryOpen ? '收起历史申请数据' : '显示历史申请数据' }}
    </el-button>

    <el-table
      v-if="isHistoryOpen && history.length > 0"
      :data="history"
      style="width: 100%; margin-top: 10px;"
      size="mini"
      border
    >
      <el-table-column prop="child_name" label="孩子姓名" min-width="120"></el-table-column>
      <el-table-column prop="hosp" label="申请机构" min-width="150"></el-table-column>
      <el-table-column prop="type" label="申请类型" min-width="120"></el-table-column>
      <el-table-column prop="ins_date" label="申请时间" min-width="150"></el-table-column>
      <el-table-column prop="shenhe_date" label="审核时间" min-width="150"></el-table-column>
    </el-table>

    <el-empty
      v-if="isHistoryOpen && history.length === 0"
      description="暂无历史申请数据"
      style="margin-top: 20px;"
    ></el-empty>
  </div>

  <!-- 更改康复类型对话框 -->
  <el-dialog
    title="更改康复类型"
    :visible.sync="changeTypeDialogVisible"
    width="400px"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    :append-to-body="true"
  >
    <div style="margin-bottom: 20px;">
      <el-radio-group v-model="selectedType">
        <el-radio label="“机构集中”">机构集中</el-radio>
        <el-radio label="“机构+社区+家庭”">机构+社区+家庭</el-radio>
      </el-radio-group>
    </div>
    <div style="text-align: right;">
      <el-button @click="changeTypeDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmChangeType">确认</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
export default {
  data() {
    return {
		history:[],
      isHistoryOpen: false, // 控制历史数据折叠状态
      changeTypeDialogVisible: false, // 控制更改康复类型对话框显示
      selectedType: '“机构集中”' // 选中的康复类型
	};
  },
  computed: {
    cjtypes() {
      return this.biao.cjtypes;
    },
    info() {
      let info = window.localStorage.getItem("info");
      return JSON.parse(info);
    },
    org() {
      let org = window.localStorage.getItem("org");
      return JSON.parse(org);
    },
  },
  watch: {
    biao() {
		this.getdata();
	},
  },
  props: ["biao"],
  methods: {
    // 时间格式化函数
    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    // 显示更改康复类型对话框
    showChangeTypeDialog() {
      this.changeTypeDialogVisible = true;
    },
    
    // 确认更改康复类型
    confirmChangeType() {
      this.$confirm('一定要联系通知家长同意无误后方可更改，是否确认更改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用API更新康复类型
        this.updateRehabType();
      }).catch(() => {
        // 用户取消操作
      });
    },
    
    // 更新康复类型
    async updateRehabType() {
      try {
        console.log({
          token: this.info.uid,
          idcard: this.biao.idcard,
          id:this.biao.id,
          rehab_type: this.selectedType
        },"我看看这是啥")
        const response = await axios.get(this.$url + 'admin/update_rehab_type', {params:{
          token: this.info.uid,
          idcard: this.biao.idcard,
          id:this.biao.id,
          rehab_type: this.selectedType
        }});
        console.log(response.data);
        
        if (response.data.status == 0) {
          this.$message.success('康复类型更改成功');
          this.changeTypeDialogVisible = false;
          // 更新本地显示的康复类型
          this.biao.type = this.selectedType;
        } else {
          this.$message.error(response.data.message || '更改失败，请重试');
        }
      } catch (error) {
        console.error('更新康复类型失败:', error);
        this.$message.error(response.data.desc);
      }
    },
    
   async getdata() {
	    console.log(this.biao.idcard,"我要看idcard是否获取了");
        let y = await axios.get(this.$url + "admin/erk_history", {
         params: {
		      token: this.info.uid,
          idcard: this.biao.idcard,
         }
      });
      
      // 格式化时间字段
      this.history = y.data.lists.map(item => ({
        ...item,
        ins_date: this.formatDateTime(item.ins_date),
        shenhe_date: this.formatDateTime(item.shenhe_date)
      }));
    },
  },
  created() {
	setTimeout(() => {
		this.getdata();
	}, 1000);
	
  },
};
</script>

<style>
</style>
